module.exports = __webpack_public_path__ + "static/media/arrow_right.d550de2e.svg";